/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowDropUp: {
  name: 'arrow-drop-up';
  data: string;
} = {
  name: 'arrow-drop-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m7 14 5-5 5 5H7z"/></svg>`
};
